import { API_CONFIG } from '../config/api';
import { secureLogger } from './secureLogger';

let faceMediaCookieExpiresAtMs = 0;
let faceMediaCookieRequest: Promise<void> | null = null;

type FaceMediaCookieResponse = {
  enabled?: boolean;
  expires_at?: number | null;
};

export const ensureFaceMediaCookie = async (accessToken: string): Promise<void> => {
  const now = Date.now();
  if (faceMediaCookieExpiresAtMs > now + 60_000) {
    return;
  }
  if (faceMediaCookieRequest) {
    return faceMediaCookieRequest;
  }

  faceMediaCookieRequest = (async () => {
    try {
      const response = await fetch(`${API_CONFIG.BASE_URL}/api/v1/persons/face-media-cookie`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${accessToken}` },
        credentials: 'include',
      });
      if (!response.ok) {
        secureLogger.error('Failed to issue face media cookie', { status: response.status });
        return;
      }
      const data = (await response.json().catch(() => ({}))) as FaceMediaCookieResponse;
      if (data.enabled && typeof data.expires_at === 'number') {
        faceMediaCookieExpiresAtMs = data.expires_at * 1000;
      }
    } catch (error) {
      secureLogger.error('Failed to issue face media cookie', { error: 'Face media cookie request failed' });
    } finally {
      faceMediaCookieRequest = null;
    }
  })();

  return faceMediaCookieRequest;
};
